import {Route} from 'entity-manager';

export enum CurrencyEnum {
    Eur = 'EUR',
    Rsd = 'RSD'
}

@Route('currencies')
export class Currency {

    protected id: string;
    protected code: string;
    protected name: string;

    public setId(id: string) {
        this.id = id;
        return this;
    }

    public getId(): string {
        return this.id;
    }

    public setCode(code: string) {
        this.code = code;
        return this;
    }

    public getCode(): string {
        return this.code;
    }

    public setName(name: string) {
        this.name = name;
        return this;
    }

    public getName(): string {
        return this.name;
    }
}
